
import {addMedicalSpecialty,deleteMedicalSpecialty,updateMedicalSpecialty,getMedicalSpecialties,getMedicalSpecialty,searchMedicalSpecialty } from '@/services/endpoints/MedicalSpecialties'
import statuses from "@/constatnts/statuses";
import localForage from "localforage";

export default {
    async addMedicalSpecialty({ commit }, payload) {
        try {
            let res = await addMedicalSpecialty(payload)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },

    async deleteMedicalSpecialty({ commit }, payload) {
        try {
            let res = await deleteMedicalSpecialty(payload.medicalSpecialtiesId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getMedicalSpecialties({ commit },payload) {
        try {
            let res = await getMedicalSpecialties(payload);
            if(res) {
                commit('SET_MEDICAL_SPECIALTIES', {medicalSpecialties : res.data.data})
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async updateMedicalSpecialty({commit},payload) {
        try {
            let res = await updateMedicalSpecialty(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchMedicalSpecialty({ commit }, payload) {
        try {
            let res = await searchMedicalSpecialty(payload);
            if(res) {
                commit('SET_MEDICAL_SPECIALTIES', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getActiveMedicalSpecialty({ commit },version = false) {
        try {
            let currentVersion = await localForage.getItem('medical-specialties-version');
            if(version && currentVersion) {
                if(version !== currentVersion) {
                    let res = await searchMedicalSpecialty({status: statuses.ACTIVE});
                    if(res) {
                        commit('SET_MEDICAL_SPECIALTIES', {version: version, medicalSpecialties: res.data.data})
                        return res.data.data
                    }
                }
                else{
                    const items = await localForage.getItem('medicalSpecialties');
                    if(!items){
                        let res = await searchMedicalSpecialty({status: statuses.ACTIVE});
                        if(res) {
                            commit('SET_MEDICAL_SPECIALTIES', {version: version, medicalSpecialties: res.data.data})
                            return res.data.data
                        }
                    }
                    else commit('SET_MEDICAL_SPECIALTIES',{status : 'fetched',items: items});
                    return items;
                }
            }
            else{
                let res = await searchMedicalSpecialty({status: statuses.ACTIVE});
                if (res) {
                    commit('SET_MEDICAL_SPECIALTIES', {version: version, medicalSpecialties: res.data.data});
                    return res.data.data
                }
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getMedicalSpecialtyToEdit({ commit }, medicalSpecialtiesId) {
        try {
            let res = await getMedicalSpecialty(medicalSpecialtiesId);
            if(res) {
                commit('SET_MEDICAL_SPECIALTY_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}